import React from 'react';
import PropTypes from 'prop-types';
import {getUniqueId} from 'utils/id-util';
import {isValid} from 'validators/number-validator';

/**
 * Chart is a component that lifts up reusable state
 * common to other chart components. It uses the render
 * props pattern to wrap a child component and pass
 * state down to it. Reusable state includes the number
 * of rows that a legend should expect to have, and
 * the current position of the tooltip.
 */
export default class Chart extends React.Component {
  static propTypes = {
    render: PropTypes.func,
  };

  static defaultProps = {
    render: () => <svg />,
  };

  constructor(props) {
    super(props);

    this.setDimensionsAfterUpdate = true;
    this.id = getUniqueId();

    this.state = {
      activeIndex: -1,
      closestIndex: -1,
      legendRows: 0,
      showTooltip: false,
      x: -1,
      y: -1,
    };

    this.handleMove = this.handleMove.bind(this);
    this.handleOut = this.handleOut.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.setLegendRows = this.setLegendRows.bind(this);

    window.addEventListener('resize', this.handleWindowResize);
  }

  componentDidMount() {
    // Second update pass to ensure that refs are accounted for.
    this.forceUpdate();
  }

  UNSAFE_componentWillReceiveProps() {
    this.setDimensionsAfterUpdate = true;
  }

  componentDidUpdate() {
    if (this.setDimensionsAfterUpdate) {
      this.setDimensionsAfterUpdate = false;
      this.forceUpdate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  setLegendRows(legendRows) {
    if (isValid(legendRows) && legendRows !== this.state.legendRows) {
      this.setState({legendRows});
    }
  }

  render() {
    return this.props.render({
      ...this.props,
      ...this.state,
      handleMove: this.handleMove,
      handleOut: this.handleOut,
      id: this.id,
      setLegendRows: this.setLegendRows,
    });
  }

  handleMove(event) {
    this.setState({
      activeIndex: event.activeIndex,
      closestIndex: event.closestIndex,
      showTooltip: true,
      x: event.x,
      y: event.y,
    });
  }

  handleOut() {
    this.setState({
      activeIndex: -1,
      closestIndex: -1,
      showTooltip: false,
      x: -1,
      y: -1,
    });
  }

  handleWindowResize() {
    this.forceUpdate();
  }
}
